import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-content-update',
  templateUrl: './content-update.component.html',
  styleUrls: ['./content-update.component.scss']
})
export class ContentUpdateComponent implements OnInit {

  constructor(public modalRef: MDBModalRef) { }

  ngOnInit(): void { window.scroll({top:0,left:0,behavior:"smooth"});
  }

}
